
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/loggingContentPane';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <option value='#loggingAuthentication'>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.logging_content_pane")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.logging_content_pane.authentication", "Login / Logout Activity", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.logging_content_pane.authentication", "Login / Logout Activity", options)))
    + "\n    </option>\n    ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <option value='#loggingGradeChange'>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.logging_content_pane")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.logging_content_pane.grade_change", "Grade Change Activity", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.logging_content_pane.grade_change", "Grade Change Activity", options)))
    + "\n    </option>\n    ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <option value='#loggingCourse'>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.logging_content_pane")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.logging_content_pane.course", "Course Activity", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.logging_content_pane.course", "Course Activity", options)))
    + "\n    </option>\n    ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <option value='#loggingMutation'>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.logging_content_pane")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.logging_content_pane.mutations", "GraphQL Mutation Activity", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.logging_content_pane.mutations", "GraphQL Mutation Activity", options)))
    + "\n    </option>\n    ";
  return buffer;
  }

function program9(depth0,data) {
  
  
  return "\n<div id=\"loggingAuthentication\" class=\"loggingTypeContent\"></div>\n";
  }

function program11(depth0,data) {
  
  
  return "\n<div id=\"loggingGradeChange\" class=\"loggingTypeContent\"></div>\n";
  }

function program13(depth0,data) {
  
  
  return "\n<div id=\"loggingCourse\" class=\"loggingTypeContent\"></div>\n";
  }

function program15(depth0,data) {
  
  
  return "\n<div id=\"loggingMutation\" class=\"loggingTypeContent\"></div>\n";
  }

  buffer += "<label class=\"control-label\" for=\"loggingType\">\n  <h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.logging_content_pane")
  },data:data},helper ? helper.call(depth0, "select_a_log_type_to_search_247fc6b4", "Select a log type to search.", options) : helperMissing.call(depth0, "t", "select_a_log_type_to_search_247fc6b4", "Select a log type to search.", options)))
    + "</h2>\n</label>\n\n<div class=\"controls\">\n  <select id=\"loggingType\">\n    <option value=\"default\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.logging_content_pane")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.logging_content_pane.select_default", "Select a Log type", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.logging_content_pane.select_default", "Select a Log type", options)))
    + "</option>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.authentication), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.grade_change), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.course), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.mutation), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </select>\n</div>\n<hr aria-hidden=\"true\"/>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.authentication), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.grade_change), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.course), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.mutation), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  